const r=()=>({getFormFieldErrorMessage:({error:r,invalid:e})=>{if(!r||!e)return"";const{message:o=""}=r;return o}});export{r as useReactHookFormValidationHelpers};
//# sourceMappingURL=useReactHookFormValidationHelpers.js.map
